module.exports = __webpack_public_path__ + "static/maskerone-06695115865bbbeb9bfea0849df5b523.jpg";